import React from "react";

import { format } from "date-fns";
import { ru } from "date-fns/locale";

import {
  Block,
  InfoBlock,
  StepContainer,
  StepTitle,
  SummaryBlock,
  TGButton,
} from "./styles";

type BookingStepSuccessProps = {
  selectedDate: Date;
  selectedSlot: string;
};

export const BookingStepSuccess: React.FC<BookingStepSuccessProps> = ({ selectedDate, selectedSlot }) => {
  return (
    <StepContainer>
      <StepTitle>Спасибо за запись</StepTitle>
      <InfoBlock>Вы успешно записаны&nbsp;
        <span>{format(selectedDate, "d MMMM", { locale: ru })}</span>&nbsp;в&nbsp;
        <span>{selectedSlot}</span> по МСК</InfoBlock>
      <SummaryBlock>
        <Block>
          <span>
            Наш менеджер предварительно свяжется с вами для подтверждения встречи.
            В день консультации вам придет ссылка на онлайн встречу в Telegram.
          </span>
        </Block>
        <Block>
          <span>
            Если у вас остались вопросы относительно нашей работы, пожалуйста,
            напишите нам:
          </span>
          <TGButton
            href="https://t.me/ProhorovaConsult"
            target="_blank"
            rel="noopener noreferrer"
          >Задать вопрос в ТГ</TGButton>
        </Block>
      </SummaryBlock>
    </StepContainer>
  );
};
